export default function hyphenfyMobileNumber(numberString: string) {
  var Number = numberString?.replace(/\D/g, "");
  if (!Number) return "";
  if (Number?.length >= 5 && Number?.length < 8) {
    return Number.replace(/(\d{4})/, "$1-");
  } else if (Number.length >= 8 && Number.length < 11) {
    return Number.replace(/(\d{4})(\d{3})/, "$1-$2-");
  } else if (Number.length >= 11) {
    return Number.replace(/(\d{4})(\d{3})(\d{4})/, "$1-$2-$3");
  } else {
    return Number;
  }
}
